import { useState } from "react";
import { X } from "lucide-react";

export default function AddDealFinanceDrawer({ isOpen, onClose }) {
  const [form, setForm] = useState({
    uniqueId: "",
    f1InvoiceNumber: "",
    f1InvoiceDate: "",
    customerName: "",
    poValue: "",
    tax: "",
    totalValue: "",
    customerAdvance: "",
    customerBalance: "",
    customerPartPayment: "",
    customerTDS: "",
    distiInvoiceNumber: "",
    f1POValue: "",
    distiInvoiceDate: "",
    otherExp: "",
    distiInvoiceValue: "",
  });

  // Separate, clean state lists for Payments Received and Distributor Cheques
  const [payments, setPayments] = useState([{ paymentType: "Advance", amount: "", date: "" }]);
  const [cheques, setCheques] = useState([{ chequeNo: "", amount: "", date: "" }]);

  if (!isOpen) return null;

  const handleChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });

  // Dynamic Methods for Payments Received
  const addPayment = () =>
    setPayments([...payments, { paymentType: "Advance", amount: "", date: "" }]);

  const updatePayment = (i, key, value) => {
    const arr = [...payments];
    arr[i][key] = value;
    setPayments(arr);
  };

  const removePayment = (i) =>
    setPayments(payments.filter((_, index) => index !== i));

  // Dynamic Methods for Distributor Cheques
  const addCheque = () =>
    setCheques([...cheques, { chequeNo: "", amount: "", date: "" }]);

  const updateCheque = (i, key, value) => {
    const arr = [...cheques];
    arr[i][key] = value;
    setCheques(arr);
  };

  const removeCheque = (i) =>
    setCheques(cheques.filter((_, index) => index !== i));

  return (
    
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
      <div
        className="absolute inset-0"
        onClick={onClose}
      ></div>

      <div className="relative w-[75%] max-w-6xl h-[90vh] bg-white rounded-xl shadow-2xl flex flex-col">
        <div className="flex justify-between items-center px-6 py-4 border-b">
          <h2 className="text-lg font-semibold">Add Deal</h2>
          <button onClick={onClose}><X /></button>
        </div>

        <div className="flex-1 overflow-y-auto p-6 space-y-8">

          {/* Customer Details Section */}
          <section>
            <h3 className="font-semibold mb-4">Customer Details</h3>

            <div className="grid grid-cols-2 gap-4">
              {[
                ["uniqueId","Unique ID"],
                ["f1InvoiceNumber","F1 Invoice Number"],
                ["f1InvoiceDate","F1 Invoice Date","date"],
                ["customerName","Customer Name"],
                ["poValue","PO Value"],
                ["tax","Tax"],
                ["totalValue","Total Value"],
                ["customerBalance","Customer Balance"],
                ["customerTDS","Customer TDS"],
              ].map(([name,label,type])=>(
                <div key={name}>
                  <label className="text-xs text-gray-500">{label}</label>
                  <input
                    type={type || "text"}
                    name={name}
                    value={form[name]}
                    onChange={handleChange}
                    className="w-full border rounded px-3 py-2 text-sm"
                  />
                </div>
              ))}
            </div>
          </section>
          {/* PAYMENT RECEIVED DROPDOWN SECTION */}
            <div className="mt-6 flex justify-between items-center">
              <h4 className="font-medium">Payment Received</h4>
              <button onClick={addPayment} className="text-blue-600 text-sm">+ Add Payment</button>
            </div>

            {payments.map((p, i) => (
              <div key={i} className="grid grid-cols-4 gap-3 mt-3">
                <select
                  className="border rounded px-3 py-2 bg-white text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 text-gray-700"
                  value={p.paymentType}
                  onChange={e => updatePayment(i, "paymentType", e.target.value)}
                >
                  <option value="Advance">Advance</option>
                  <option value="Part">Part</option>
                  <option value="Full">Full</option>
                </select>
                
                <input 
                  placeholder="Amount" 
                  className="border rounded px-3 py-2 text-sm"
                  type="number"
                  value={p.amount}
                  onChange={e => updatePayment(i, "amount", e.target.value)}
                />
                
                <input 
                  type="date" 
                  className="border rounded px-3 py-2 text-sm"
                  value={p.date}
                  onChange={e => updatePayment(i, "date", e.target.value)}
                />
                
                <button
                  className="border rounded px-3 py-2 text-red-500 hover:bg-red-50 transition text-sm font-medium"
                  onClick={() => removePayment(i)}
                >
                  Remove
                </button>
              </div>
            ))}

          {/* Distributor & Payments Section */}
          <section>
            <h3 className="font-semibold mb-4">Distributor Details</h3>

            <div className="grid grid-cols-2 gap-4">
              {[
                ["distiInvoiceNumber","Disti Invoice Number"],
                ["f1POValue","F1 PO Value"],
                ["distiInvoiceDate","Disti Invoice Date","date"],
                ["otherExp","Other Exp"],
                ["distiInvoiceValue","Disti Invoice Value"],
              ].map(([name,label,type])=>(
                <div key={name}>
                  <label className="text-xs text-gray-500">{label}</label>
                  <input
                    type={type || "text"}
                    name={name}
                    value={form[name]}
                    onChange={handleChange}
                    className="w-full border rounded px-3 py-2 text-sm"
                  />
                </div>
              ))}
            </div>

            

            {/* DISTRIBUTOR CHEQUES SECTION */}
            <div className="mt-6 flex justify-between items-center">
              <h4 className="font-medium">Distributor Cheques</h4>
              <button onClick={addCheque} className="text-blue-600 text-sm">+ Add Cheque</button>
            </div>

            {cheques.map((c, i) => (
              <div key={i} className="grid grid-cols-4 gap-3 mt-3">
                <input 
                  placeholder="Cheque Number" 
                  className="border rounded px-3 py-2 text-sm"
                  value={c.chequeNo}
                  onChange={e => updateCheque(i, "chequeNo", e.target.value)}
                />
                
                <input 
                  placeholder="Amount" 
                  className="border rounded px-3 py-2 text-sm"
                  type="number"
                  value={c.amount}
                  onChange={e => updateCheque(i, "amount", e.target.value)}
                />
                
                <input 
                  type="date" 
                  className="border rounded px-3 py-2 text-sm"
                  value={c.date}
                  onChange={e => updateCheque(i, "date", e.target.value)}
                />
                
                <button
                  className="border rounded px-3 py-2 text-red-500 hover:bg-red-50 transition text-sm font-medium"
                  onClick={() => removeCheque(i)}
                >
                  Remove
                </button>
              </div>
            ))}
          </section>

        </div>

        <div className="border-t px-6 py-3 flex justify-end gap-3 bg-white rounded-b-xl">
          <button onClick={onClose} className="border px-4 py-2 rounded">Cancel</button>
          <button className="bg-blue-600 text-white px-4 py-2 rounded">Save</button>
        </div>
      </div>
    </div>
  );
}